<div class="partner-logo-container">
	<span class="logo-align">
		<img class="partner-logo" [src]="logo" alt="Logo" />
	</span>
</div>
